import { Inject, Injectable } from '@angular/core';
import { APP_CONTEXT_TOKEN } from '@core/context';
import { Channels } from '../../shared/enums/channels.enum';
import { IHotelStaticInfo } from '@core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { RoomPrice } from '../../shared/enums/room-price.enum';

@Injectable({
  providedIn: 'root',
})
export class ReqService {
  private site: string;
  private statusCode: number;
  private isbot: boolean;
  private locale: string;
  private country: string;
  private channel: string;
  private brand: string;
  private page: string;
  private light: string;
  private hotelStaticInfo: IHotelStaticInfo;
  private alliances: string[];
  private landing: boolean;
  private _allowDollar: boolean;
  private _disableARS: boolean;

  constructor(@Inject(APP_CONTEXT_TOKEN) public context) {
    console.log(context)
    this.alliances = ['superclub', 'davivienda'];
    this.site = this.context.site;
    this.channel = this.context.channel;
    this.page = this.context.page;
    this.light = this.context.light;
    this.locale = this.context.locale;
    this.country = this.context.country;
    this.brand = this.context.brand;
    this.isbot = this.context.isbot;
    this.hotelStaticInfo = this.context.hotelStaticInfo;
    this.statusCode = this.context.statusCode;
    this.landing = this.context.isLanding;
    this._allowDollar = this.context.allowDollar;
    this._disableARS = this.context.disableARS;
  }

  public getLocale(): string {
    return this.locale;
  }

  public getCountry(): string {
    return this.country;
  }

  public getChannel(): string {
    return this.channel;
  }

  public getHotelStaticInfo(): IHotelStaticInfo {
    return this.hotelStaticInfo;
  }

  public getSite(): string {
    return this.site;
  }

  public getBrand(): string {
    return this.brand;
  }

  public getLight(): string {
    return this.light;
  }

  public getPage(): string {
    return this.page;
  }

  public isBra(): boolean {
    return this.context.local === 'pt-BR';
  }

  public isExperts(): boolean {
    const expertsChannels = [Channels.CCR, Channels.RETAIL];
    return expertsChannels.includes(this.context.channel.toLowerCase());
  }

  public isCVC(): boolean {
    return this.context.company.toUpperCase() === 'CVC';
  }

  public isBot(): boolean {
    return this.isbot;
  }

  public isDisneyHotel(): boolean {
    return this.hotelStaticInfo.chain.code === 'DISNEY';
  }

  public isAlliance(): boolean {
    return this.alliances.includes(this.brand);
  }

  public getStatusCode(): number {
    return this.statusCode;
  }

  public get isLanding(): boolean {
    return this.landing;
  }

  public get allowDollar(): boolean {
    return this._allowDollar;
  }

  public get disableARS(): boolean {
    return this._disableARS;
  }

  public get priceBy(): RoomPrice {
    return this.context.params.priceBy !== undefined
      ? this.context.params.priceBy
      : RoomPrice.BY_NIGHT;
  }
}
